/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as CryptoJS from 'crypto-js'
if (typeof window !== 'undefined') {
  window.CryptoJS = CryptoJS
}

/**
 * Part of implementing Anti Request Forgery Headers.
 * See `calculations.js` for more implementation.
 * https://docs.google.com/document/d/1yc7xhd_ED8xrlFY4A7COPNpAMowgIpwwkSThMut2kmA/edit#
 *
 * This file is purposefully vaguely named,
 * to aid in making it harder to reverse engineer.
 *
 * We are hiding the use of the `CryptoJS` library.
 *
 * Prepares things on the global object for the `utils/Calculations.js` file.
 */
export function initialize() {
  if (typeof window !== 'undefined') {
    window.toHmacSHA256 = CryptoJS.HmacSHA256
    window.toSHA256 = CryptoJS.SHA256
    window.toBase64 = CryptoJS.enc.Base64.stringify.bind(CryptoJS.enc.Base64)

    // We are hiding the use of the `CryptoJS` library.
    const fromCharCode = String.fromCharCode.bind(null)

    // 'toBase64'
    const toBase64 = fromCharCode(116, 111, 66, 97, 115, 101, 54, 52)
    // 'toHmacSHA256'
    const toHmacSHA256 = fromCharCode(116, 111, 72, 109, 97, 99, 83, 72, 65, 50, 53, 54)
    // 'sha256'
    const toSHA256 = fromCharCode(116, 111, 83, 72, 65, 50, 53, 54)

    // 'CryptoJS'
    const encodedCryptoJS = fromCharCode(67, 114, 121, 112, 116, 111, 74, 83)
    // 'enc'
    const encodedEnc = fromCharCode(101, 110, 99)
    // 'Base64'
    const encodedBase64 = fromCharCode(66, 97, 115, 101, 54, 52)
    // 'stringify'
    const stringify = fromCharCode(115, 116, 114, 105, 110, 103, 105, 102, 121)
    // 'HmacSHA256'
    const encodedHmacSHA256 = fromCharCode(72, 109, 97, 99, 83, 72, 65, 50, 53, 54)
    // 'SHA256'
    const encodedSHA256 = fromCharCode(83, 72, 65, 50, 53, 54)

    const w = window
    // @ts-ignore
    const cryptoJs = w[encodedCryptoJS]
    const base64 = cryptoJs[encodedEnc][encodedBase64]
    // @ts-ignore
    w[toBase64] = base64[stringify].bind(base64)
    // @ts-ignore
    w[toHmacSHA256] = cryptoJs[encodedHmacSHA256]
    // @ts-ignore
    w[toSHA256] = cryptoJs[encodedSHA256]
  }
}
